import { RSAA } from 'redux-api-middleware';
import { replace } from 'connected-react-router';
import {
  VALIDATE_INVITE_TOKEN_REQUESTED,
  VALIDATE_INVITE_TOKEN_SUCCESS,
  VALIDATE_INVITE_TOKEN_FAILURE,
  ACCEPT_INVITATION_REQUESTED,
  ACCEPT_INVITATION_SUCCESS,
  ACCEPT_INVITATION_FAILURE,
} from '../actions';

const validateInviteTokenActionSet = (jwt) => ({
  [RSAA]: {
    types: [
      VALIDATE_INVITE_TOKEN_REQUESTED,
      VALIDATE_INVITE_TOKEN_SUCCESS,
      VALIDATE_INVITE_TOKEN_FAILURE,
    ],
    method: 'POST',
    endpoint: '/userinvite/validate/',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ jwt }),
  },
});

export const validateInviteToken = (jwt) => (dispatch) =>
  dispatch(validateInviteTokenActionSet(jwt));

const acceptInvitationActionSet = (newJwt, data, needsSignup) => {
  let userData;
  if (needsSignup) {
    userData = {
      new_jwt: newJwt,
      password: data.password,
      firstname: data.firstname,
      lastname: data.lastname,
    };
  } else {
    userData = {
      new_jwt: newJwt,
      password: '',
      firstname: '',
      lastname: '',
    };
  }

  return {
    [RSAA]: {
      types: [
        ACCEPT_INVITATION_REQUESTED,
        {
          type: ACCEPT_INVITATION_SUCCESS,
          meta: {
            analytics: true,
          },
        },
        ACCEPT_INVITATION_FAILURE,
      ],
      method: 'POST',
      endpoint: '/userinvite/accept/',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(userData),
    },
  };
};

export const acceptInvitation = (newJwt, data, needsSignup) => (dispatch) =>
  dispatch(acceptInvitationActionSet(newJwt, data, needsSignup));

export const acceptInvitationRedirect = () => (dispatch) =>
  // We should redirect to /login but since there are situations where we send and receive the
  // invite in the same computer(like a demo for a customer) then we redirect to /logout to clear
  // all the variables. NOTE that being in PRIVATE MODE applies only cookies. Local storage still
  // inherited (not shared) between tabs and different windows even when in private mode.
  dispatch(replace('/logout'));
